'use client'
import React, { ReactNode } from 'react'
import { usePathname } from 'next/navigation'

export default function ProviderSwitch({
	children,
}: {
	readonly children: ReactNode
}) {
	const pathname = usePathname()

	if (pathname === '/feature/dashboard/compass-poc') {
		return null
	}

	return <>{children}</>
}
